import React, { useEffect, useState } from 'react';
import KwPanel from '../../common/KwPanel';
import Loading from '../../common/Loading';
import { useTranslation } from 'react-i18next';
import { getRecentRequestsByScopes } from '../../../api/requestApi';
import { ParseBoolean } from '../../../util/formatter';
import RecentRequestsList from './RecentRequestsList';

export interface RecentRequestsPanelProps {
  from: Date;
  to: Date;
  scopes: Record<string, string>;
}

function RecentRequestsPanel({ from, to, scopes }: RecentRequestsPanelProps) {
  const { t } = useTranslation();

  const [data, setData] = useState<any[]>();
  const [isLoading, setIsLoading] = useState(false);

  const scopesKey = JSON.stringify(scopes ?? {});
  const hideKeyRequestGroupedDetail =
    ParseBoolean(window.globalConfig?.hideKeyRequestGroupedDetail) ||
    ParseBoolean(process.env.REACT_APP_HIDE_KEY_REQUEST_GROUPED_DETAIL);

  useEffect(() => {
    setIsLoading(true);
    getRecentRequestsByScopes(scopes ?? {}, from, to)
      .then((res) => {
        setData(res?.data ?? []);
      })
      .catch((e) => {
        console.error(e);
        setData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [from, to, scopesKey]);

  return (
    <KwPanel className="mb-0">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2 className="no-margin">{t('Recent requests')}</h2>
      </div>

      {isLoading && <Loading />}

      {!isLoading && data && data.length === 0 && (
        <div className="text-muted">{t('No requests found')}</div>
      )}

      {!isLoading && data && data.length > 0 && (
        <RecentRequestsList
          data={data}
          hideKeyRequestGroupedDetail={hideKeyRequestGroupedDetail}
        />
      )}
    </KwPanel>
  );
}

export default RecentRequestsPanel;
